import React from 'react';
import PropTypes from 'prop-types';
import FieldContainer from '../BaseComponent/FieldContainer';
import TextField from '../BaseComponent/TextField';

const NumberField = ({
  field,
  label,
  propsFromForm,
  textClassName,
  ...props
}) => {
  return (
    <FieldContainer>
      <TextField
        field={field}
        label={label}
        propsFromForm={propsFromForm}
        textClassName={textClassName}
        type="number"
        {...props}
      />
    </FieldContainer>
  );
};

NumberField.propTypes = {
  field: PropTypes.object.isRequired,
  label: PropTypes.string,
  propsFromForm: PropTypes.object,
  textClassName: PropTypes.string,
};

export default NumberField;
